import { TextArea } from '../../common/fields/TextArea'
import { NpsStep } from './NPSStepBasePage'
import { FieldIds, MAX_FEEDBACK_LENGTH, NPSStepId, NPSStepProps, StepIds } from './types'
import { NPSRecordState } from './NPSViewModel'
import { NPSWorkflowStep } from './useNPSFormWorkflowCoordinator'
import { validateFeedback } from './validation'

export const RATIONALE_STEP = {
    id: StepIds.SCORE_RATIONALE,
    validate: ({ getFieldValue }: NPSRecordState) => {
        return validateFeedback(getFieldValue(FieldIds.SCORE_RATIONALE))
    },
} as const satisfies NPSWorkflowStep<NPSStepId>

export function NPSStepRationalePage(props: NPSStepProps) {
    const {
        recordForm: { getField },
    } = props

    return (
        <NpsStep
            {...props}
            title={getField(FieldIds.SCORE_RATIONALE)!.label!}
            fieldGroups={[
                [
                    {
                        id: FieldIds.SCORE_RATIONALE,
                        icon: 'note.large',
                        label: 'Primary reason',
                        statusLine: (value: unknown) =>
                            `${(typeof value === 'string' ? value : '').length} / ${MAX_FEEDBACK_LENGTH}`,
                        render: (value: unknown, onChange: (value: unknown) => void) => (
                            <TextArea
                                isAutoResizing
                                placeholder="Enter your primary reason"
                                value={typeof value === 'string' ? value : undefined}
                                onChange={(e) => onChange(e.target.value)}
                                maxLength={MAX_FEEDBACK_LENGTH}
                            />
                        ),
                    },
                ],
            ]}
        />
    )
}
